function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 18");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "Group-18",
  transform: "translate(0.700000, 1.000000)",
  stroke: "#FFFFFF"
}, React.createElement("g", {
  id: "notebook-copy"
}, React.createElement("path", {
  d: "M12.6666667,0 L12.6666667,16 L0.974358974,16 C0.436235372,16 0,15.6020309 0,15.1111111 L0,0.888888889 C0,0.397969111 0.436235372,0 0.974358974,0 L12.6666667,0 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M0,14 L0,13.3333333 C0,12.9651435 0.436235372,12.6666667 0.974358974,12.6666667 L12.6666667,12.6666667",
  id: "Path"
})), React.createElement("path", {
  d: "M3.8,4.66666667 L8.86666667,4.66666667",
  id: "Path",
  strokeWidth: 2
})));

var SvgLibraryIcon = function SvgLibraryIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLibraryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/library-icon.90a5ceae.svg";
export { ForwardRef as ReactComponent };